import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { blTableCustomStyles } from "../../../utils/TableCustomStyles";
import Select from "react-select";
import { smallFormSelectCustomStyles } from "../../../utils/SelectCustomStyles";
import logoBlInoxShipping from "../../../images/inox_bl_logo.jpg";
import blBackSideTerms from "../../../images/bl_terms.jpg"
import { format } from "date-fns";
import { downloadPDF } from "../../../utils/downloadPdf";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";



function PlannedExportBl(props) {
  const addblform = useRef(null);
  const [shipmentData, setShipmentData] = useState([]);
  const [shipmentBlData, setShipmentBlData] = useState([]);
  const [shipmentContainerData, setShipmentContainerData] = useState([]);
  const [packageData, setPackageData] = useState([]);
  const [signAsEnitityData, setSignAsEnitityData] = useState([]);
  const [shipmentBlDataPending, setShipmentBlDataPending] = useState(false);
  const [shipmentContainerDataPending, setShipmentContainerDataPending] = useState(false);
  const [containerEditableRows, setContainerEditableRows] = useState({});

  const shipment_id = props.shipmentId
  const agentList = props.agentList
  const portList = props.portList
  const vesselList = props.vesselList
  const currentUserRolePermissionData = props.currentUserRolePermissionData
  const loggedInUser = props.loggedInUser

  // ----------------------- BL --------------------------------
  const [showAddShipmentBlModal, setShowAddShipmentBlModal] = useState(false);
  const [showUpdateShipmentBlModal, setShowUpdateShipmentBlModal] = useState(false);
  const [showDeleteShipmentBlModal, setShowDeleteShipmentBlModal] = useState(false);

  const [blConsignerDetails, setBlConsignerDetails] = useState("");
  const [blConsigneeDetails, setBlConsigneeDetails] = useState("");
  const [blNotifyPartyDetails, setBlNotifyPartyDetails] = useState("");
  const [blDeliveryAgentDetails, setBlDeliveryAgentDetails] = useState("");

  const [updateShipmentBlId, setUpdateShipmentBlId] = useState("");
  const [updateBlNumber, setUpdateBlNumber] = useState("");
  const [updateBlType, setUpdateBlType] = useState("");
  const [updateBlSubType, setUpdateBlSubType] = useState("");
  const [updateBlConsigner, setUpdateBlConsigner] = useState("");
  const [updateBlConsignerDetails, setUpdateBlConsignerDetails] = useState("");
  const [updateBlConsignee, setUpdateBlConsignee] = useState("");
  const [updateBlConsigneeDetails, setUpdateBlConsigneeDetails] = useState("");
  const [updateBlNotifyParty, setUpdateBlNotifyParty] = useState("");
  const [updateBlNotifyPartyDetails, setUpdateBlNotifyPartyDetails] = useState("");
  const [updateBlDeliveryAgent, setUpdateBlDeliveryAgent] = useState("");
  const [updateBlDeliveryAgentDetails, setUpdateBlDeliveryAgentDetails] = useState("");
  const [updateBlStatus, setUpdateBlStatus] = useState("");
  const [updateMarksAndNos, setUpdateMarksAndNos] = useState("");
  const [updateBlDescription, setUpdateBlDescription] = useState("");
  const [updatePodFreeDays, setUpdatePodFreeDays] = useState(0);
  const [updateGrossWeight, setUpdateGrossWeight] = useState("");
  const [updateNetWeight, setUpdateNetWeight] = useState("");
  const [updateMeasurement, setUpdateMeasurement] = useState("");
  const [updateStamp1, setUpdateStamp1] = useState("");
  const [updateStamp2, setUpdateStamp2] = useState("");
  const [updateStamp3, setUpdateStamp3] = useState("");
  const [updateStamp4, setUpdateStamp4] = useState("");
  const [updateStamp5, setUpdateStamp5] = useState("");
  const [updateFreightPayment, setUpdateFreightPayment] = useState("");
  const [updateTotalOriginals, setUpdateTotalOriginals] = useState("");
  const [updateIssuePlace, setUpdateIssuePlace] = useState("");
  const [updateIssueDate, setUpdateIssueDate] = useState(null);
  const [updateCargoValue, setUpdateCargoValue] = useState("");
  const [updateSignAs, setUpdateSignAs] = useState("");
  const [updateSigningEntity, setUpdateSigningEntity] = useState("");

  const [addShipmentBlLoader, setAddShipmentBlLoader] = useState(false);
  const [updateShipmentBlLoader, setUpdateShipmentBlLoader] = useState(false);
  const [deleteShipmentBlLoader, setDeleteShipmentBlLoader] = useState(false);
  const [deleteShipmentBlId, setDeleteShipmentBlId] = useState("");

  const [showPrintBlModal, setShowPrintBlModal] = useState(false);
  const [showBlBackModal, setShowBlBackModal] = useState(false);
  const [showPreviewPrintBlModal, setShowPreviewPrintBlModal] = useState(false);
  const [printWithClause, setPrintWithClause] = useState(false);
  const [printWithStamp, setPrintWithStamp] = useState(false);
  const [printWithSignature, setPrintWithSignature] = useState(false);
  const [showPrintPreview, setShowPrintPreview] = useState(false);
  

  const getShipment = async (shipment_id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/booking/' + shipment_id);
      if (response) {
        setShipmentData(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching shipment data! Try again.");
    }
  }

  const getShipmentBl = async (shipment_id) => {
    setShipmentBlDataPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentbl?shipment=' + shipment_id);
      if (response) {
        setShipmentBlData(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching shipment bl data! Try again.");
    }
    setShipmentBlDataPending(false)
  }

  const getShipmentContainer = async (shipment_id) => {
    setShipmentContainerDataPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer?shipment=' + shipment_id);
      if (response) {
        setShipmentContainerData(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching shipment container data! Try again.");
    }
    setShipmentContainerDataPending(false)
  }

  const getPackage = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/packagetype');
      if (response) {
         const sorted_data = [...response.data].sort((a, b) => String(a.code).localeCompare(String(b.code), undefined, { numeric: true }));
        setPackageData(sorted_data)
      }
    } catch (err) {
      toast.error("Error in fetching package type data! Try again.");
    }
  }

  useEffect(() => {
    getPackage()
  }, []);

  useEffect(() => {
    getShipment(shipment_id)
    getShipmentBl(shipment_id)
    getShipmentContainer(shipment_id)
  }, [shipment_id]);

  const shipmentcontainercolumns = [
    {
      name: 'Container No.',
      selector: row => row.container?.container_number,
      sortable: true,
    },
    {
      name: 'Type',
      selector: row => row.container?.type == "HD20" ? "20HD" : 
                      row.type == "HD40" ? "40HD" :
                      row.type == "GP20" ? "20GP" :
                      row.type == "GP40" ? "40GP" :
                      "40HQ",
      sortable: true,
    },
    {
      name: 'Agent Seal',
      center: true,
      selector: row => 
        <div className="d-flex flex-row">
          {loggedInUser?.role_array?.includes("customer") ?
          <input type="text" 
              className="form-control form-control-sm" 
              value={containerEditableRows[row.id]?.agent_seal || 0}
              onChange={e =>
                setContainerEditableRows(prev => ({
                  ...prev,
                  [row.id]: {
                    ...prev[row.id],
                    agent_seal: e.target.value,
                  },
                }))
              }
              onBlur={(e) => handleAgentSeal(e, row.id, containerEditableRows[row.id]?.agent_seal)}
            >  
          </input>
          :
          row.agent_seal ?? "-"}
        </div>,
      sortable: true,
    },
    {
      name: 'Customs Seal',
      center: true,
      selector: row => 
        <div className="d-flex flex-row">
          {loggedInUser?.role_array?.includes("customer") ?
          <input type="text" 
              className="form-control form-control-sm" 
              value={containerEditableRows[row.id]?.customs_seal || 0}
              onChange={e =>
                setContainerEditableRows(prev => ({
                  ...prev,
                  [row.id]: {
                    ...prev[row.id],
                    customs_seal: e.target.value,
                  },
                }))
              }
              onBlur={(e) => handleCustomsSeal(e, row.id, containerEditableRows[row.id]?.customs_seal)}
              >
          </input>
          :
          row.customs_seal ?? "-"}
        </div>,
      sortable: true,
    },
    {
      name: 'Pakage Type',
      width: '250px',
      center: true,
      selector: row => 
        <div className="d-flex flex-row">
          {loggedInUser?.role_array?.includes("customer") ?
          <select className={`form-select form-select-sm`} onChange={(e) => handleContainerPackageType(e, row?.id, e.target.value)}>
            <option value="" selected={row.status == "" ? true : false} disabled>Select Type</option>
            {packageData?.map(pkg => (
              <option value={pkg.id} selected={pkg.id==row.package_type_data?.id?true:false} className={`${pkg.id==row.package_type_data?.id?"bg-inox-green text-white":""}`}>{pkg.name}</option>
            ))}
          </select>
          :
          row.status ?? "-"}
        </div>,
      sortable: true,
    },
    {
      name: 'No. of Pkgs',
      center: true,
      selector: row => 
        <div className="d-flex flex-row">
          {loggedInUser?.role_array?.includes("customer") ?
          <input type="number" 
                className="form-control form-control-sm" 
                value={containerEditableRows[row.id]?.number_of_packages || 0}
                onChange={e =>
                  setContainerEditableRows(prev => ({
                    ...prev,
                    [row.id]: {
                      ...prev[row.id],
                      number_of_packages: e.target.value,
                    },
                  }))
                }
                onBlur={(e) => handleNumberOfPackages(e, row.id, containerEditableRows[row.id]?.number_of_packages)}
              >
          </input>
          :
          row.number_of_packages ?? "-"}
        </div>,
      sortable: true,
    },
    {
      name: 'CBM',
      center: true,
      selector: row => 
        <div className="d-flex flex-row">
          {loggedInUser?.role_array?.includes("customer") ?
          <input type="number" 
                className="form-control form-control-sm" 
                value={containerEditableRows[row.id]?.cbm || 0}
                onChange={e =>
                  setContainerEditableRows(prev => ({
                    ...prev,
                    [row.id]: {
                      ...prev[row.id],
                      cbm: e.target.value,
                    },
                  }))
                }
                onBlur={(e) => handleCbm(e, row.id, containerEditableRows[row.id]?.cbm)}
            >
          </input>
          :
          row.cbm ?? "-"}
        </div>,
      sortable: true,
    },
    {
      name: 'Gross Weight',
      center: true,
      selector: row => 
        <div className="d-flex flex-row">
          {loggedInUser?.role_array?.includes("customer") ?
          <input type="number" 
                className="form-control form-control-sm" 
                value={containerEditableRows[row.id]?.gross_weight || 0}
                onChange={e =>
                  setContainerEditableRows(prev => ({
                    ...prev,
                    [row.id]: {
                      ...prev[row.id],
                      gross_weight: e.target.value,
                    },
                  }))
                }
                onBlur={(e) => handleGrossWeight(e, row.id, containerEditableRows[row.id]?.gross_weight)}
            > 
          </input>
          :
          row.gross_weight ?? "-"}
        </div>,
      sortable: true,
    },
    {
      name: 'Net Weight',
      center: true,
      selector: row => 
        <div className="d-flex flex-row">
          {loggedInUser?.role_array?.includes("customer") ?
          <input type="number" 
                className="form-control form-control-sm" 
                value={containerEditableRows[row.id]?.net_weight || 0}
                onChange={e =>
                  setContainerEditableRows(prev => ({
                    ...prev,
                    [row.id]: {
                      ...prev[row.id],
                      net_weight: e.target.value,
                    },
                  }))
                }
                onBlur={(e) => handleNetWeight(e, row.id, containerEditableRows[row.id]?.net_weight)}
            > 
          </input>
          :
          row.net_weight ?? "-"}
        </div>,
      sortable: true,
    },
    {
      name: 'Unit',
      center: true,
      selector: row => 
        <div className="d-flex flex-row">
          {loggedInUser?.role_array?.includes("customer") ?
          <select className={`form-select form-select-sm`} onChange={(e) => handleWeightUnit(e, row?.id, e.target.value)}>
            <option value="" selected={row.kgs_mts == "" ? true : false} disabled>Select Unit</option>
            <option value="KGS" selected={row.kgs_mts=="KGS"?true:false}>KGS</option>
            <option value="MTS" selected={row.kgs_mts=="MTS"?true:false}>MTS</option>
          </select>
          :
          row.status ?? "-"}
        </div>,
      sortable: true,
    }
  ];

  useEffect(() => {
    const initial = {};
    shipmentContainerData.forEach(row => {
      initial[row.id] = {
        agent_seal: row.agent_seal || 0,
        customs_seal: row.customs_seal || 0,
        number_of_packages: row.number_of_packages || 0,
        cbm: row.cbm || 0,
        gross_weight: row.gross_weight || 0,
        net_weight: row.net_weight || 0,
        kgs_mts: row.kgs_mts || "",
        package_type: row.package_type_data?.id || "",
      };
    });
    setContainerEditableRows(initial);
  }, [shipmentContainerData]);

  const handleContainerPackageType = async (e, container_id, package_type) => {
    e.preventDefault();

    const id = container_id

    const data = {
      id: id,
      package_type: package_type,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try{
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { 'content-type': 'application/json' } });
      if (response.status === 200) {
        toast.success("Package type updated successfully")
      }
    } catch (err) {
      toast.error("Error in updating package type! Try again.");
    }

    getShipmentContainer(shipment_id)
  }

  const handleAgentSeal = async (e, container_id, agent_seal) => {
    e.preventDefault();
    const id = container_id

    const data = {
      id: id,
      agent_seal: agent_seal,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try{
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { 'content-type': 'application/json' } });
      if (response.status === 200) {
        toast.success("Agent Seal updated successfully")
      }
    } catch (err) {
      toast.error("Error in updating agent seal! Try again.");
    }

    getShipmentContainer(shipment_id)
  }

  const handleCustomsSeal = async (e, container_id, customs_seal) => {
    e.preventDefault();
    const id = container_id

    const data = {
      id: id,
      customs_seal: customs_seal,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try{
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { 'content-type': 'application/json' } });
      if (response.status === 200) {
        toast.success("Customs Seal updated successfully")
      }
    } catch (err) {
      toast.error("Error in updating customs seal! Try again.");
    }

    getShipmentContainer(shipment_id)
  }

  const handleNumberOfPackages = async (e, container_id, number_of_packages) => {
    e.preventDefault();
    const id = container_id

    const data = {
      id: id,
      number_of_packages: number_of_packages,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try{
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { 'content-type': 'application/json' } });
      if (response.status === 200) {
        toast.success("No. of packages updated successfully")
      }
    } catch (err) {
      toast.error("Error in updating no of packages! Try again.");
    }

    getShipmentContainer(shipment_id)
  }

  const handleCbm = async (e, container_id, cbm) => {
    e.preventDefault();
    const id = container_id

    const data = {
      id: id,
      cbm: cbm,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try{
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { 'content-type': 'application/json' } });
      if (response.status === 200) {
        toast.success("Cbm updated successfully")
      }
    } catch (err) {
      toast.error("Error in updating cbm! Try again.");
    }

    getShipmentContainer(shipment_id)
  }

  const handleGrossWeight = async (e, container_id, gross_weight) => {
    e.preventDefault();
    const id = container_id

    const data = {
      id: id,
      gross_weight: gross_weight,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try{
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { 'content-type': 'application/json' } });
      if (response.status === 200) {
        toast.success("Gross weight updated successfully")
      }
    } catch (err) {
      toast.error("Error in updating gross weight! Try again.");
    }

    getShipmentContainer(shipment_id)
  }

  const handleNetWeight = async (e, container_id, net_weight) => {
    e.preventDefault();
    const id = container_id

    const data = {
      id: id,
      net_weight: net_weight,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try{
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { 'content-type': 'application/json' } });
      if (response.status === 200) {
        toast.success("Net weight updated successfully")
      }
    } catch (err) {
      toast.error("Error in updating net weight! Try again.");
    }

    getShipmentContainer(shipment_id)
  }

  const handleWeightUnit = async (e, container_id, weight_unit) => {
    e.preventDefault();
    const id = container_id

    const data = {
      id: id,
      kgs_mts: weight_unit,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try{
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentcontainer/'+id+'/', data, { headers: { 'content-type': 'application/json' } });
      if (response.status === 200) {
        toast.success("Weight unit updated successfully")
      }
    } catch (err) {
      toast.error("Error in updating weight unit! Try again.");
    }

    getShipmentContainer(shipment_id)
  }

  const shipmentblcolumns = [
    {
      name: 'BL Number',
      width: '160px',
      selector: row => row.bl_number,
      sortable: true,
    },
    {
      name: 'BL Type',
      width: '100px',
      selector: row => row.shipment_data?.bl_type,
      sortable: true,
    },
    {
      name: 'BL Sub Type',
      width: '120px',
      selector: row => row.shipment_data?.bl_sub_type,
      sortable: true,
    },
    {
      name: 'Route',
      width: '300px',
      selector: row => 
        <div>
          <p className="mb-0"><b>POA:</b> {row.shipment_data?.poa_data?.name}</p>
          <p className="mb-0"><b>POL:</b> {row.shipment_data?.pol_data?.name}</p>
          <p className="mb-0"><b>POD:</b> {row.shipment_data?.pod_data?.name}</p>
          <p className="mb-0"><b>FD:</b> {row.shipment_data?.fd_data?.name}</p>
        </div>,
      sortable: true,
    },
    {
      name: 'Consigner',
      selector: row => row.consigner,
      sortable: true,
    },
    {
      name: 'Consignee',
      selector: row => row.consignee,
      sortable: true,
    },
    {
      name: 'Notify Party',
      selector: row => row.notify_party,
      sortable: true,
    },
    {
      name: 'Delivery Agent',
      width: '140px',
      selector: row => row.delivery_agent_data?.name,
      sortable: true,
    },
    {
      name: 'Status',
      width: '140px',
      selector: row => <span className={`${row.status=="ISSUED"?"bg-success text-white px-2 rounded":row.status=="CANCELLED"?"bg-danger text-white px-2 rounded":""}`}>{row.status}</span>,
      sortable: true,
    },
    {
      name: 'Action',
      width: '110px',
      center: true,
      selector: row =>
        <div>
          {
            currentUserRolePermissionData?.includes("shipment:bl:update") ?
              <Button className="btn btn-sm btn-inox-green border-0 my-1" style={{ height: 30 }} title="Update" onClick={() => handleShowUpdateShipmentBlModal(row)}>
                <i className="fa fa-edit"></i>
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("shipment:bl:delete") ?
              <Button className="btn btn-sm btn-danger my-1 mx-1" style={{ height: 30 }} title="Delete" onClick={() => handleDeleteShipmentBlModal(row)}>
                <i className="fa fa-trash"></i>
              </Button>
              :
              ""
          }
        </div>,
    }
  ];

  const handleShowAddShipmentBlModal = () => {
    setShowAddShipmentBlModal(true)
  }

  const handleCloseAddShipmentBlModal = () => {
    setShowAddShipmentBlModal(false)
  }

  const handleShowUpdateShipmentBlModal = async (data) => {
    setShowUpdateShipmentBlModal(true)
    setUpdateShipmentBlId(data?.id)
    setUpdateBlNumber(data?.bl_number)
    setUpdateBlType(data?.bl_type)
    setUpdateBlSubType(data?.bl_sub_type)
    setUpdateBlConsigner(data?.consigner)
    setUpdateBlConsignerDetails(data?.consigner_details)
    setUpdateBlConsignee(data?.consignee)
    setUpdateBlConsigneeDetails(data?.consignee_details)
    setUpdateBlNotifyParty(data?.notify_party)
    setUpdateBlNotifyPartyDetails(data?.notify_party_details)
    setUpdateBlDeliveryAgent(data?.delivery_agent)
    setUpdateBlDeliveryAgentDetails(data?.delivery_agent_details)

    setUpdateMarksAndNos(data?.marks_and_nos)
    setUpdateBlDescription(data?.description)
    setUpdatePodFreeDays(data?.pod_free_days == 0? shipmentData?.pod_detention_free_days:data?.pod_free_days)
    setUpdateNetWeight(data?.net_weight)
    setUpdateMeasurement(data?.measurement)
    setUpdateStamp1(data?.stamp_1)
    setUpdateStamp2(data?.stamp_2)
    setUpdateStamp3(data?.stamp_3)
    setUpdateStamp4(data?.stamp_4)
    setUpdateStamp5(data?.stamp_5)
    setUpdateFreightPayment(data?.freight_payment)
    setUpdateTotalOriginals(data?.total_originals)
    setUpdateIssuePlace(data?.issue_place)
    setUpdateIssueDate(data?.issue_date)
    setUpdateCargoValue(data?.cargo_value)
    setUpdateSignAs(data?.sign_as)
    setUpdateSigningEntity(JSON.parse(data?.signing_entity))
    handleSignAs(data?.sign_as)
  }

  const handleUpdateShipmentBlModalClose = () => {
    setShowUpdateShipmentBlModal(false)
    setUpdateShipmentBlId("")
    setUpdateBlNumber("")
    setUpdateBlType("")
    setUpdateBlSubType("")
    setUpdateBlConsigner("")
    setUpdateBlConsignerDetails("")
    setUpdateBlConsignee("")
    setUpdateBlConsigneeDetails("")
    setUpdateBlNotifyParty("")
    setUpdateBlNotifyPartyDetails("")
    setUpdateBlDeliveryAgent("")
    setUpdateBlDeliveryAgentDetails("")
  }

  const handleDeleteShipmentBlModal = (row) => {
    setShowDeleteShipmentBlModal(true)
    setDeleteShipmentBlId(row.id)
  }

  const addShipmentBl = async (e) => {
    e.preventDefault();
    setAddShipmentBlLoader(true)

    const data = {
      "shipment": shipment_id,
      "bl_number": shipmentData?.reference_number,
      "bl_type": addblform.current.bl_type.value,
      "bl_sub_type": addblform.current.bl_sub_type.value,
      "consigner": addblform.current.consigner.value,
      "consigner_details": blConsignerDetails,
      "consignee": addblform.current.consignee.value,
      "consignee_details": blConsigneeDetails,
      "notify_party": addblform.current.notify_party.value,
      "notify_party_details": blNotifyPartyDetails,
      "delivery_agent": addblform.current.delivery_agent.value,
      "delivery_agent_details": blDeliveryAgentDetails,
      "created_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentbl/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 201) {
        toast.success("BL generated successfully");
        getShipmentBl(shipment_id)
        addblform.current.bl_type.value = ""
        addblform.current.bl_sub_type.value = ""
        addblform.current.consigner.value = ""
        addblform.current.consignee.value = ""
        addblform.current.notify_party.value = ""
        addblform.current.delivery_agent.value = ""
        setBlConsignerDetails("")
        setBlConsigneeDetails("")
        setBlNotifyPartyDetails("")
        setBlDeliveryAgentDetails("")
      }
    } catch (err) {
      toast.error("Error in generating bl! Try again.");
    }

    getShipmentBl(shipment_id)
    setAddShipmentBlLoader(false)
    setShowAddShipmentBlModal(false)
  }

  const updateShipmentBl = async (e) => {
    e.preventDefault();
    setUpdateShipmentBlLoader(true)

    const signing_entity_response = updateSignAs=="AGENT"?await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/agent/'+updateSigningEntity):
                                    updateSignAs=="PRINCIPAL"?await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/principal/'+updateSigningEntity):""

    const data = {
      "id": updateShipmentBlId,
      "consigner": updateBlConsigner,
      "consigner_details": updateBlConsignerDetails,
      "consignee": updateBlConsignee,
      "consignee_details": updateBlConsigneeDetails,
      "notify_party": updateBlNotifyParty,
      "notify_party_details": updateBlNotifyPartyDetails,
      "delivery_agent": updateBlDeliveryAgent,
      "delivery_agent_details": updateBlDeliveryAgentDetails,
      "marks_and_nos": updateMarksAndNos,
      "description": updateBlDescription,
      "pod_free_days": updatePodFreeDays,
      "gross_weight": updateGrossWeight,
      "net_weight": updateNetWeight,
      "measurement": updateMeasurement,
      "stamp_1": updateStamp1,
      "stamp_2": updateStamp2,
      "stamp_3": updateStamp3,
      "stamp_4": updateStamp4,
      "stamp_5": updateStamp5,
      "freight_payment": updateFreightPayment,
      "total_originals": updateTotalOriginals,
      "issue_place": updateIssuePlace,
      "issue_date": updateIssueDate,
      "cargo_value": updateCargoValue,
      "sign_as": updateSignAs,
      "signing_entity": JSON.stringify(signing_entity_response?.data),
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentbl/'+updateShipmentBlId+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("BL updated successfully");
        getShipmentBl(shipment_id)
      }
    } catch (err) {
      toast.error("Error in updating bl! Try again.");
    }

    getShipmentBl(shipment_id)
    setShowUpdateShipmentBlModal(false)
    setUpdateShipmentBlLoader(false)
  }

  const deleteShipmentBl = async (e) => {
    e.preventDefault();
    setDeleteShipmentBlLoader(true)

    const id = deleteShipmentBlId

    try {
      const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentbl/' + id + '/');

      if (response.status == 204) {
        toast.success("Bl deleted successfully");
        getShipmentBl(shipment_id)
      }
    } catch (err) {
      toast.error("Error in deleting Bl! Try again.");
    }
    setDeleteShipmentBlLoader(false)
    setShowDeleteShipmentBlModal(false)
  }

  const handleSignAs = async(value) => {
    setUpdateSignAs(value)
    
    try {
      if(value=="AGENT"){
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/agent');
        if (response) {
          setSignAsEnitityData(response.data)
        }
      }
      else if(value=="PRINCIPAL"){
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/principal');
        if (response) {
          setSignAsEnitityData(response.data)
        }
      }
      else{
        setSignAsEnitityData([])
      }
    } catch (err) {
      toast.error("Error in fetching sign in entity data! Try again.");
    }
  }

  return (
    <div>
      <div className="col-12 text-left" style={{ marginTop: -5 }}>
        <div className="row">
          <div className="col-9">
            <Button className="btn btn-inox-green border-0" onClick={() => handleShowAddShipmentBlModal()}>Add BL</Button>
          </div>
        </div>

        <DataTable
          columns={shipmentblcolumns}
          data={shipmentBlData}
          progressPending={shipmentBlDataPending}
          progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
          noDataComponent={<p className="text-center table-no-data">No BL Found</p>}
          highlightOnHover
          customStyles={blTableCustomStyles}
          dense
        />
      </div>

      <Modal dialogClassName="update-bl-modal" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showAddShipmentBlModal} onHide={() => handleCloseAddShipmentBlModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add BL</Modal.Title>
        </Modal.Header>
        <Modal.Body>          
          <form ref={addblform}>
            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>BL Details</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">BL Number</label>
                    <div class="col-12">
                      <input type="text" id="bl_number" name="bl_number" className="form-control form-control-sm" disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="bl_type" class="col-12 col-form-label font-12px">BL Type</label>
                    <div class="col-12">
                      <select id="bl_type" name="bl_type" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.bl_type==""?true:false}>Select BL Type</option>
                        <option value="ORIGINAL" selected={shipmentData?.bl_type=="ORIGINAL"?true:false}>ORIGINAL BL</option>
                        <option value="SURRENDER" selected={shipmentData?.bl_type=="SURRENDER"?true:false}>SURRENDER BL</option>
                        <option value="SEA_WAY" selected={shipmentData?.bl_type=="SEA_WAY"?true:false}>SEAWAY BL</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="bl_type" class="col-12 col-form-label font-12px">BL Sub Type</label>
                    <div class="col-12">
                      <select id="bl_sub_type" name="bl_sub_type" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.bl_sub_type==""?true:false}>Select BL Type</option>
                        <option value="NA" selected={shipmentData?.bl_sub_type=="NA"?true:false}>NA</option>
                        <option value="PART_BL" selected={shipmentData?.bl_sub_type=="PART_BL"?true:false}>PART BL</option>
                        <option value="SWITCH_BL" selected={shipmentData?.bl_sub_type=="SWITCH_BL"?true:false}>SWITCH BL</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Route</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="poa" class="col-12 col-form-label font-12px">POA</label>
                    <div class="col-12">
                      <select id="poa" name="poa" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.poa==""?true:false}>Select POA</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.poa==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="pol" class="col-12 col-form-label font-12px">POL</label>
                    <div class="col-12">
                      <select id="pol" name="pol" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.pol==""?true:false}>Select POL</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.pol==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="pod" class="col-12 col-form-label font-12px">POD</label>
                    <div class="col-12">
                      <select id="pod" name="pod" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.pod==""?true:false}>Select POD</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.pod==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="fd" class="col-12 col-form-label font-12px">FD</label>
                    <div class="col-12">
                      <select id="fd" name="fd" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.fd==""?true:false}>Select FD</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.fd==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Vessel Details</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Vessel</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.first_vessel_schedule_data?.vessel_data?.id == "" ? true : false}>Select Vessel</option>
                        {vesselList?.map(vessel => (
                          <option value={vessel.id} selected={vessel.id == shipmentData?.first_vessel_schedule_data?.vessel_data?.id ? true : false}>{vessel.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Voyage</label>
                    <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="voyage" name="voyage" value={shipmentData?.first_vessel_schedule_data?.voyage} disabled/>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Consigner</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="consigner" class="col-12 col-form-label font-12px">Consigner</label>
                     <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="consigner" name="consigner"></input>
                    </div>
                  </div>
                </div>

                <div className="col-9">
                  <div class="form-group mb-2">
                    <label for="consigner_details" class="col-12 col-form-label font-12px">Consigner Details</label>
                    <div class="col-12">
                      <CKEditor
                        editor={ClassicEditor}
                        id="consigner_details"
                        name="consigner_details"
                        config={{
                          toolbar: [
                            'heading', '|',
                            'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                            'undo', 'redo', 'sourceEditing'
                          ]
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setBlConsignerDetails(data);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Consignee</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="consignee" class="col-12 col-form-label font-12px">Consignee</label>
                     <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="consignee" name="consignee"></input>
                    </div>
                  </div>
                </div>

                <div className="col-9">
                  <div class="form-group mb-2">
                    <label for="consignee_details" class="col-12 col-form-label font-12px">Consignee Details</label>
                    <div class="col-12">
                      <CKEditor
                        editor={ClassicEditor}
                        id="consignee_details"
                        name="consignee_details"
                        config={{
                          toolbar: [
                            'heading', '|',
                            'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                            'undo', 'redo', 'sourceEditing'
                          ]
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setBlConsigneeDetails(data);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Notify Party</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="notify_party" class="col-12 col-form-label font-12px">Notify Party</label>
                     <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="notify_party" name="notify_party"></input>
                    </div>
                  </div>
                </div>

                <div className="col-9">
                  <div class="form-group mb-2">
                    <label for="notify_party_details" class="col-12 col-form-label font-12px">Notify Party Details</label>
                    <div class="col-12">
                      <CKEditor
                        editor={ClassicEditor}
                        id="notify_party_details"
                        name="notify_party_details"
                        config={{
                          toolbar: [
                            'heading', '|',
                            'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                            'undo', 'redo', 'sourceEditing'
                          ]
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setBlNotifyPartyDetails(data);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            
            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Delivery Agent</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="delivery_agent" class="col-12 col-form-label font-12px">Delivery Agent</label>
                     <div class="col-12">
                      <select id="delivery_agent" name="delivery_agent" className="form-select form-select-sm">
                        <option value="" selected={shipmentData?.delivery_agent == ""?true:false}>Select Delivery Agent</option>
                        {agentList?.map(agent => (
                          <option value={agent.id} selected={shipmentData?.delivery_agent == agent.id?true:false}>{agent.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-9">
                  <div class="form-group mb-2">
                    <label for="delivery_agent_details" class="col-12 col-form-label font-12px">Delivery Agent Details</label>
                    <div class="col-12">
                      <CKEditor
                        editor={ClassicEditor}
                        id="delivery_agent_details"
                        name="delivery_agent_details"
                        config={{
                          toolbar: [
                            'heading', '|',
                            'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                            'undo', 'redo', 'sourceEditing'
                          ]
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setBlDeliveryAgentDetails(data);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <div className="col-12 text-center">
              <Button className="btn btn-inox-green border-0 mt-3" onClick={(e) => addShipmentBl(e)}>
                {addShipmentBlLoader ?
                  <Spinner className="mx-5 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  :
                  "Add BL"
                }
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>


      <Modal style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showUpdateShipmentBlModal} onHide={() => [handleUpdateShipmentBlModalClose(), setPrintWithStamp(false), setPrintWithSignature(false)]} dialogClassName="update-bl-modal" centered>
        <Modal.Header closeButton>
          <Modal.Title>Update BL</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <div class="dropdown">
                <button type="button" style={{ paddingTop: 7, paddingBottom: 8, float: 'right' }} title="Language" class="btn btn-inox-green border-0 text-white" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span class="d-flex align-items-center">
                    <span className="fa fa-bars"></span>
                  </span>
                </button>

                <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end">
                  <span class="dropdown-item pointer pointer" onClick={() => console.log("Release")}>
                    <i className="fa fa-check text-success"></i><span className="mx-2">Release</span>
                  </span>

                  <span class="dropdown-item pointer pointer" onClick={() => console.log("Surrender")}>
                    <i className="fa fa-exclamation text-warning"></i><span className="mx-2">Surrender</span>
                  </span>

                  <span class="dropdown-item pointer pointer" onClick={() => console.log("Mark Seaway")}>
                    <i className="fa fa-ship text-info"></i><span className="mx-2">Mark Seaway</span>
                  </span>

                  <span class="dropdown-item pointer pointer" onClick={() => console.log("Mark Expressway")}>
                    <i className="fa fa-road text-secondary"></i><span className="mx-2">Mark Expressway</span>
                  </span>

                  <span class="dropdown-item pointer pointer" onClick={() => console.log("Switch")}>
                    <i className="fa fa-refresh text-warning"></i><span className="mx-2">Switch</span>
                  </span>

                  <span class="dropdown-item pointer pointer" onClick={() => setShowPrintBlModal(true)}>
                    <i className="fa fa-print text-inox-green"></i><span className="mx-2">Print NN</span>
                  </span>

                  <span class="dropdown-item pointer pointer" onClick={() => setShowBlBackModal(true)}>
                    <i className="fa fa-file text-inox-red"></i><span className="mx-2">Print BL Back</span>
                  </span>

                  <span class="dropdown-item pointer pointer" onClick={() => console.log("All")}>
                    <i className="fa fa-envelope text-success"></i><span className="mx-2">Issued OBL Email</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <form>
            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>BL Details</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">BL Number</label>
                    <div class="col-12">
                      <input type="text" id="bl_number" name="bl_number" className="form-control form-control-sm" value={updateBlNumber} disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="bl_type" class="col-12 col-form-label font-12px">BL Type</label>
                    <div class="col-12">
                      <select id="bl_type" name="bl_type" className="form-select form-select-sm" disabled>
                        <option value="" selected={updateBlType==""?true:false}>Select BL Type</option>
                        <option value="ORIGINAL" selected={updateBlType=="ORIGINAL"?true:false}>ORIGINAL BL</option>
                        <option value="SURRENDER" selected={updateBlType=="SURRENDER"?true:false}>SURRENDER BL</option>
                        <option value="SEA_WAY" selected={updateBlType=="SEA_WAY"?true:false}>SEAWAY BL</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="bl_type" class="col-12 col-form-label font-12px">BL Sub Type</label>
                    <div class="col-12">
                      <select id="bl_sub_type" name="bl_sub_type" className="form-select form-select-sm" disabled>
                        <option value="" selected={updateBlSubType==""?true:false}>Select BL Type</option>
                        <option value="NA" selected={updateBlSubType=="NA"?true:false}>NA</option>
                        <option value="PART_BL" selected={updateBlSubType=="PART_BL"?true:false}>PART BL</option>
                        <option value="SWITCH_BL" selected={updateBlSubType=="SWITCH_BL"?true:false}>SWITCH BL</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Route</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="poa" class="col-12 col-form-label font-12px">POA</label>
                    <div class="col-12">
                      <select id="poa" name="poa" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.poa==""?true:false}>Select POA</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.poa==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="pol" class="col-12 col-form-label font-12px">POL</label>
                    <div class="col-12">
                      <select id="pol" name="pol" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.pol==""?true:false}>Select POL</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.pol==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="pod" class="col-12 col-form-label font-12px">POD</label>
                    <div class="col-12">
                      <select id="pod" name="pod" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.pod==""?true:false}>Select POD</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.pod==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="fd" class="col-12 col-form-label font-12px">FD</label>
                    <div class="col-12">
                      <select id="fd" name="fd" className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.fd==""?true:false}>Select FD</option>
                        {portList?.map(port => (
                          <option value={port.id} selected={shipmentData?.fd==port.id?true:false}>{port.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Vessel Details</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Vessel</label>
                    <div class="col-12">
                      <select className="form-select form-select-sm" disabled>
                        <option value="" selected={shipmentData?.first_vessel_schedule_data?.vessel_data?.id == "" ? true : false}>Select Vessel</option>
                        {vesselList?.map(vessel => (
                          <option value={vessel.id} selected={vessel.id == shipmentData?.first_vessel_schedule_data?.vessel_data?.id ? true : false}>{vessel.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label class="col-12 col-form-label font-12px">Voyage</label>
                    <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="voyage" name="voyage" value={shipmentData?.first_vessel_schedule_data?.voyage} disabled/>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Consigner</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="consigner" class="col-12 col-form-label font-12px">Consigner</label>
                     <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="consigner" name="consigner" value={updateBlConsigner}
                      onChange={(e) => setUpdateBlConsigner(e.target.value)}></input>
                    </div>
                  </div>
                </div>

                <div className="col-9">
                  <div class="form-group mb-2">
                    <label for="consigner_details" class="col-12 col-form-label font-12px">Consigner Details</label>
                    <div class="col-12">
                      <CKEditor
                        editor={ClassicEditor}
                        id="consigner_details"
                        name="consigner_details"
                        config={{
                          toolbar: [
                            'heading', '|',
                            'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                            'undo', 'redo', 'sourceEditing'
                          ]
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setUpdateBlConsignerDetails(data);
                        }}
                        data={updateBlConsignerDetails}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Consignee</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="consignee" class="col-12 col-form-label font-12px">Consignee</label>
                     <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="consignee" name="consignee" value={updateBlConsignee}
                      onChange={(e) => setUpdateBlConsignee(e.target.value)}></input>
                    </div>
                  </div>
                </div>

                <div className="col-9">
                  <div class="form-group mb-2">
                    <label for="consignee_details" class="col-12 col-form-label font-12px">Consignee Details</label>
                    <div class="col-12">
                      <CKEditor
                        editor={ClassicEditor}
                        id="consignee_details"
                        name="consignee_details"
                        config={{
                          toolbar: [
                            'heading', '|',
                            'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                            'undo', 'redo', 'sourceEditing'
                          ]
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setUpdateBlConsigneeDetails(data);
                        }}
                        data={updateBlConsigneeDetails}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Notify Party</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="notify_party" class="col-12 col-form-label font-12px">Notify Party</label>
                     <div class="col-12">
                      <input type="text" className="form-control form-control-sm" id="notify_party" name="notify_party" value={updateBlNotifyParty}
                      onChange={(e) => setUpdateBlNotifyParty(e.target.value)}></input>
                    </div>
                  </div>
                </div>

                <div className="col-9">
                  <div class="form-group mb-2">
                    <label for="notify_party_details" class="col-12 col-form-label font-12px">Notify Party Details</label>
                    <div class="col-12">
                      <CKEditor
                        editor={ClassicEditor}
                        id="notify_party_details"
                        name="notify_party_details"
                        config={{
                          toolbar: [
                            'heading', '|',
                            'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                            'undo', 'redo', 'sourceEditing'
                          ]
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setUpdateBlNotifyPartyDetails(data);
                        }}
                        data={updateBlNotifyPartyDetails}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            
            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Delivery Agent</legend>
              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="delivery_agent" class="col-12 col-form-label font-12px">Delivery Agent</label>
                     <div class="col-12">
                      <select id="delivery_agent" name="delivery_agent" className="form-select form-select-sm" onChange={(e) => setUpdateBlDeliveryAgent(e.target.value)}>
                        <option value="" selected={updateBlDeliveryAgent == ""?true:false}>Select Delivery Agent</option>
                        {agentList?.map(agent => (
                          <option value={agent.id} selected={updateBlDeliveryAgent == agent.id?true:false}>{agent.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-9">
                  <div class="form-group mb-2">
                    <label for="delivery_agent_details" class="col-12 col-form-label font-12px">Delivery Agent Details</label>
                    <div class="col-12">
                      <CKEditor
                        editor={ClassicEditor}
                        id="delivery_agent_details"
                        name="delivery_agent_details"
                        config={{
                          toolbar: [
                            'heading', '|',
                            'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                            'undo', 'redo', 'sourceEditing'
                          ]
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setUpdateBlDeliveryAgentDetails(data);
                        }}
                        data={updateBlDeliveryAgentDetails}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Containers</legend>
              <div className="row">
                <div className="col-12">
                  <DataTable
                    columns={shipmentcontainercolumns}
                    data={shipmentContainerData}
                    progressPending={shipmentContainerDataPending}
                    progressComponent={<Spinner className="mx-5 text-inox-green my-5" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                    noDataComponent={<p className="text-center my-5">No Containers Picked</p>}
                    highlightOnHover
                    customStyles={blTableCustomStyles}
                    dense
                  />
                </div>
              </div>
            </fieldset>

            <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
              <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Others</legend>
              <div className="row">
                <div className="col-4">
                  <div class="form-group mb-2">
                    <label for="marks_and_nos" class="col-12 col-form-label font-12px">Marks & No.</label>
                     <div class="col-12">
                      <CKEditor
                        editor={ClassicEditor}
                        id="marks_and_nos"
                        name="marks_and_nos"
                        config={{
                          toolbar: [
                            'heading', '|',
                            'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                            'undo', 'redo', 'sourceEditing'
                          ]
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setUpdateMarksAndNos(data);
                        }}
                        data={updateMarksAndNos?? ""}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-4">
                  <div class="form-group mb-2">
                    <label for="description" class="col-12 col-form-label font-12px">Description</label>
                     <div class="col-12">
                      <CKEditor
                        editor={ClassicEditor}
                        id="marks_and_nos"
                        name="marks_and_nos"
                        config={{
                          toolbar: [
                            'heading', '|',
                            'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',
                            'undo', 'redo', 'sourceEditing'
                          ]
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setUpdateBlDescription(data);
                        }}
                        data={updateBlDescription ?? ""}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-4">
                  <div class="form-group mb-2">
                    <label for="pod_free_days" class="col-12 col-form-label font-12px">POD Free Days</label>
                     <div class="col-12">
                      <div className="d-flex">
                        <input type="number" 
                            name="pod_free_days" 
                            id="pod_free_days" 
                            className="form-control form-control-sm flex-grow-1" 
                            style={{ flex: '0 0 15%', borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }}
                            value={updatePodFreeDays} 
                            onChange={(e) => setUpdatePodFreeDays(e.target.value)} disabled/>

                        <textarea 
                            name="pod_free_days_text" 
                            id="pod_free_days_text" 
                            className="form-control form-control-sm flex-grow-3" 
                            rows={shipmentData?.pod_data?.country_data?.long_name == "India"?2:1}
                            style={{ flex: '0 0 85%', borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' }}
                            value={shipmentData?.pod_data?.country_data?.long_name == "India"?"DAYS FREE DETENTION AT DESTINATION NOT APPLICABLE FOR DPD CONSIGNEE":"DAYS FREE DETENTION AT DESTINATION"} 
                            disabled/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="gross_weight" class="col-12 col-form-label font-12px">Total Gross Weight (in Kg)</label>
                     <div class="col-12">
                      <input type="number" name="gross_weight" id="gross_weight" className="form-control form-control-sm" value={updateGrossWeight} onChange={(e) => setUpdateGrossWeight(e.target.value)}/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="net_weight" class="col-12 col-form-label font-12px">Total Net Weight (in Kg)</label>
                     <div class="col-12">
                      <input type="number" name="net_weight" id="net_weight" className="form-control form-control-sm" value={updateNetWeight} onChange={(e) => setUpdateNetWeight(e.target.value)}/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="measurement" class="col-12 col-form-label font-12px">Measurement</label>
                     <div class="col-12">
                      <input type="text" name="measurement" id="measurement" className="form-control form-control-sm" value={updateMeasurement} onChange={(e) => setUpdateMeasurement(e.target.value)}/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="cargo_value" class="col-12 col-form-label font-12px">Cargo Value</label>
                     <div class="col-12">
                      <input type="text" name="cargo_value" id="cargo_value" className="form-control form-control-sm" value={updateCargoValue} onChange={(e) => setUpdateCargoValue(e.target.value)}/>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="stamp_1" class="col-12 col-form-label font-12px">Stamp 1</label>
                     <div class="col-12">
                      <select name="stamp_1" id="stamp_1" className="form-select form-select-sm" onChange={(e) => setUpdateStamp1(e.target.value)}>
                        <option value="" selected={updateStamp1==""?true:false} disabled>Select Stamp</option>
                        <option value="RECEIVED_FOR_SHIPMENT" selected={updateStamp1=="RECEIVED_FOR_SHIPMENT"?true:false}>RECEIVED FOR SHIPMENT</option>
                        <option value="SHIPPED_ON_BOARD" selected={updateStamp1?.includes("SHIPPED_ON_BOARD")?true:false}>SHIPPED ON BOARD DATED</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="stamp_2" class="col-12 col-form-label font-12px">Stamp 2</label>
                     <div class="col-12">
                      <select name="stamp_2" id="stamp_2" className="form-select form-select-sm" onChange={(e) => setUpdateStamp2(e.target.value)}>
                        <option value="" selected={updateStamp2==""?true:false} disabled>Select Stamp</option>
                        <option value="SHIPPERS_LOAD_/_STOW,_COUNT_&_SEAL" selected={updateStamp2=="SHIPPERS_LOAD_/_STOW,_COUNT_&_SEAL"?true:false}>SHIPPERS LOAD / STOW, COUNT & SEAL</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="stamp_3" class="col-12 col-form-label font-12px">Stamp 3</label>
                     <div class="col-12">
                      <input type="text" name="stamp_3" id="stamp_3" className="form-control form-control-sm" value={updateStamp3} onChange={(e) => setUpdateStamp3(e.target.value)}/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="stamp_4" class="col-12 col-form-label font-12px">Stamp 4</label>
                     <div class="col-12">
                      <select name="stamp_4" id="stamp_4" className="form-select form-select-sm" onChange={(e) => setUpdateStamp4(e.target.value)} style={{ whiteSpace: 'normal'}}>
                        <option value="" selected={updateStamp4==""?true:false} disabled>Select Stamp</option>
                        <option value="ALL_DESTINATION_THC,_PHC,_CMC,_OCR,_REPAIR_&_PREVALENT_CHARGES_ON_CONSIGNEE’S_ACCOUNT" 
                                selected={updateStamp4=="ALL_DESTINATION_THC,_PHC,_CMC,_OCR,_REPAIR_&_PREVALENT_CHARGES_ON_CONSIGNEE’S_ACCOUNT"?true:false}>
                          ALL DESTINATION THC, PHC, CMC, OCR, REPAIR & PREVALENT CHARGES ON CONSIGNEE’S ACCOUNT
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="stamp_5" class="col-12 col-form-label font-12px">Stamp 5</label>
                     <div class="col-12">
                      <input type="text" name="stamp_5" id="stamp_5" className="form-control form-control-sm" value={updateStamp5} onChange={(e) => setUpdateStamp5(e.target.value)}/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="freight_payment" class="col-12 col-form-label font-12px">Freight Payment</label>
                     <div class="col-12">
                      <select name="freight_payment" id="freight_payment" className="form-select form-select-sm" onChange={(e) => setUpdateFreightPayment(e.target.value)}>
                        <option value="PREPAID" selected={updateFreightPayment=="PREPAID"?true:false}>PREPAID</option>
                        <option value="COLLECT" selected={updateFreightPayment=="COLLECT"?true:false}>COLLECT</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="total_originals" class="col-12 col-form-label font-12px">Total Originals</label>
                     <div class="col-12">
                      <select name="total_originals" id="total_originals" className="form-select form-select-sm" onChange={(e) => setUpdateTotalOriginals(e.target.value)}>
                        <option value="ZERO" selected={updateTotalOriginals=="ZERO"?true:false}>ZERO</option>
                        <option value="ONE" selected={updateTotalOriginals=="ONE"?true:false}>ONE</option>
                        <option value="TWO" selected={updateTotalOriginals=="TWO"?true:false}>TWO</option>
                        <option value="THREE" selected={updateTotalOriginals=="THREE"?true:false}>THREE</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="issue_place" class="col-12 col-form-label font-12px">Issue Place</label>
                     <div class="col-12">
                      <input type="text" name="issue_place" id="issue_place" className="form-control form-control-sm" value={updateIssuePlace} onChange={(e) => setUpdateIssuePlace(e.target.value)}/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="issue_date" class="col-12 col-form-label font-12px">Issue Date</label>
                     <div class="col-12">
                      <input type="date" name="issue_date" id="issue_date" className="form-control form-control-sm" value={updateIssueDate} onChange={(e) => setUpdateIssueDate(e.target.value)}/>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="sign_as" class="col-12 col-form-label font-12px">Sign As</label>
                     <div class="col-12">
                      <select name="sign_as" id="sign_as" className="form-select form-select-sm" onChange={(e) => handleSignAs(e.target.value)}>
                        <option value="AGENT" selected={updateSignAs=="AGENT"?true:false}>AGENT</option>
                        <option value="PRINCIPAL" selected={updateSignAs=="PRINCIPAL"?true:false}>PRINCIPAL</option>
                        <option value="CARRIER" selected={updateSignAs=="CARRIER"?true:false}>CARRIER</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-3">
                  <div class="form-group mb-2">
                    <label for="signing_entity" class="col-12 col-form-label font-12px">Signing Entity</label>
                     <div class="col-12">
                      <select name="signing_entity" id="signing_entity" className="form-select form-select-sm" onChange={(e) => setUpdateSigningEntity(e.target.value)}>
                        <option value="" selected={updateSigningEntity==""?true:false}>Select Signing Entity</option>
                        {signAsEnitityData.map(entity => (
                          <option value={entity?.id} selected={entity?.id==updateSigningEntity?.id?true:false}>{entity.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <div className="col-12 text-center">
              <Button className="btn btn-inox-green border-0 mt-3" onClick={(e) => updateShipmentBl(e)}>
                {updateShipmentBlLoader ?
                  <Spinner className="mx-5 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  :
                  "Update BL"
                }
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showDeleteShipmentBlModal} onHide={() => setShowDeleteShipmentBlModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete BL</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-12">
                Do you want to delete this bl?
              </div>

              <div className="col-12 text-center mt-4">
                <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={(e) => setShowDeleteShipmentBlModal(false)}>Cancel</Button>

                <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => deleteShipmentBl(e)}>
                  {deleteShipmentBlLoader ?
                    <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    :
                    "Delete"
                  }
                </Button>


              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>


      {/*  ---------------------------_PRINT BL ---------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showPrintBlModal} onHide={() => setShowPrintBlModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Options</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-12">
                <label className="d-flex align-items-center">
                  <input type="checkbox" className="me-2" onChange={(e) => setPrintWithClause(e.target.checked)}/> Print With Clause
                </label>

                <label className="d-flex align-items-center mt-2">
                  <input type="checkbox" className="me-2" onChange={(e) => setPrintWithStamp(e.target.checked)}/> Print With Stamp
                </label>

                <label className="d-flex align-items-center mt-2">
                  <input type="checkbox" className="me-2" onChange={(e) => setPrintWithSignature(e.target.checked)}/> Print With Signature
                </label>
              </div>

              <div className="col-12 text-center mt-4">
                <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => [setShowPrintBlModal(false), setPrintWithClause(false), setPrintWithStamp(false), setPrintWithSignature(false)]}>Cancel</Button>

                <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => [setShowPreviewPrintBlModal(true), setShowPrintBlModal(false)]}>Preview</Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal size="xl" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showPreviewPrintBlModal} onHide={() => [setShowPreviewPrintBlModal(false), setPrintWithClause(false), setPrintWithStamp(false), setPrintWithSignature(false)]} centered>
        <Modal.Header closeButton>
          <Modal.Title>Print Bill of Lading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div id="blDocument" className="col-12 px-5" style={{ textTransform: 'uppercase', fontSize: '12px', paddingTop: "30px" }}>
              <div className="row">
                <div className="col-8">
                  <div class="row">
                    <div className="col-12 border py-2" style={{ height: 150 }}>
                      <h5>SHIPPER</h5>
                      <p className="mb-0 font-11px">{updateBlConsigner}</p>
                      <p className="font-11px" dangerouslySetInnerHTML={{ __html: updateBlConsignerDetails }}></p>
                    </div>

                    <div className="col-12 border py-2" style={{ height: 150 }}>
                      <h5>CONSIGNEE</h5>
                      <p className="mb-0 font-11px">{updateBlConsignee}</p>
                      <p className="font-11px" dangerouslySetInnerHTML={{ __html: updateBlConsigneeDetails }}></p>
                    </div>

                    <div className="col-12 border py-2" style={{ height: 150 }}>
                      <h5>NOTIFY PARTY</h5>
                      <p className="mb-0 font-11px">{updateBlNotifyParty}</p>
                      <p className="font-11px" dangerouslySetInnerHTML={{ __html: updateBlNotifyPartyDetails }}></p>
                    </div>
                  </div>
                </div>
                <div className="col-4 text-center border py-2" style={{ height: 450 }}>
                  <p className="text-center fw-bold">BILL OF LADING FOR PORT TO PORT OR COMBINED TRANSPORT</p>
                  <img src={logoBlInoxShipping} class="img-fluid text-center mb-2"></img>
                  <p className="float-left mt-4"><b>BL No:</b> {updateBlNumber}</p>
                </div>
              </div>

              <div className="row">
                <div className="col-8 border py-3">
                  <p className="mb-0">VESSEL / VOYAGE</p>
                  <p className="mb-0">{shipmentData?.first_vessel_schedule_data?.vessel_data?.name} / {shipmentData?.first_vessel_schedule_data?.voyage}</p>
                </div>
                <div className="col-4 border py-2">
                  <p className="fw-bold text-center py-3 mb-0">NON-NEGOTIABLE COPY</p>
                </div>
              </div>

              <div className="row">
                <div className="col-8 border py-2">
                  <p className="mb-0">PLACE OF ACCEPTANCE</p>
                  <p className="mb-0">{shipmentData?.poa_data?.name}</p>
                </div>
                <div className="col-4 border py-2">
                  <p className="mb-0">PORT OF LOADING</p>
                  <p className="mb-0">{shipmentData?.pol_data?.name}</p>
                </div>
              </div>

              <div className="row">
                <div className="col-8 border py-2">
                  <p className="mb-0">PORT OF DISCHARGE</p>
                  <p className="mb-0">{shipmentData?.pod_data?.name}</p>
                </div>
                <div className="col-4 border py-2">
                  <p className="mb-0">PLACE OF DELIVERY</p>
                  <p className="mb-0">{shipmentData?.fd_data?.name}</p>
                </div>
              </div>

              <div className="row">
                <div className="col-4 border py-2 text-center">
                  <p className="mb-0 border-bottom fw-bold" style={{ height: '40px '}}>CONTAINER DETAILS</p>
                  <table className="w-100 mt-2 font-10px">
                    <tr className="text-left">
                      <th className="border px-1">Agent Seal</th>
                      <th className="border px-1">Customs Seal</th>
                      <th className="border px-1">Package</th>
                      <th className="border px-1">Gross Weight</th>
                    </tr>

                    {shipmentContainerData.map(container => (
                      <tr className="text-left">
                        <td className="border px-1">{container.agent_seal}</td>
                        <td className="border px-1">{container.customs_seal}</td>
                        <td className="border px-1">{container.package_type_data?.name}</td>
                        <td className="border px-1">{container.gross_weight} {container.kgs_mts}</td>
                      </tr>
                    ))}
                  </table>

                  <p className="text-left mt-2 fw-bold">MARKS & NOs.</p>
                  <p className="font-11px text-left" dangerouslySetInnerHTML={{ __html: updateMarksAndNos }}></p>
                </div>
                <div className="col-5 border py-2 text-center">
                  <p className="mb-0 fw-bold">GENERAL DESCRIPTION OF GOODS</p>
                  <p className="mb-0 border-bottom" style={{ height: '25px '}}>(PARTICULARS BELOW ARE FURNISHED BY SHIPPER / CONSIGNEE)</p>

                  <div className="text-left py-3">
                    <p className="font-11px" dangerouslySetInnerHTML={{ __html: updateBlDescription }}></p>
                  </div>
                </div>
                <div className="col-3 border py-2 text-center">
                  <p className="mb-0 border-bottom fw-bold" style={{ height: '40px '}}>WEIGHT & MEASUREMENT</p>
                  <p className="font-11px text-left mt-2" dangerouslySetInnerHTML={{ __html: updateMeasurement }}></p>
                </div>
              </div>

              <div className="row">
                <div className="col-6 border py-2">
                  <p className="mb-0">{updateStamp1}</p>
                </div>
                <div className="col-3 border py-2">
                  <p className="mb-0">{updateStamp2}</p>
                </div>
                <div className="col-3 border py-2">
                  <p className="mb-0">{updateStamp3}</p>
                </div>
              </div>

              <div className="row">
                <div className="col-9 border py-2">
                  <p className="mb-0 uppercase">{updateStamp4}</p>
                </div>
                <div className="col-3 border py-2">
                  <p className="mb-0">{updateStamp5}</p>
                </div>
              </div>

              <div className="row">
                <div className="col-9">
                  <div className="row">
                    <div className="col-8 border py-2" style={{ height: '180px' }}>
                      <h5>DELIVERY AGENT</h5>
                      <p className="mb-0 font-11px">{updateBlDeliveryAgent}</p>
                      <p className="font-11px" dangerouslySetInnerHTML={{ __html: updateBlDeliveryAgentDetails }}></p>
                    </div>
                    <div className="col-4">
                      <div className="row">
                         <div className="col-12 py-2 border-bottom">
                          <p className="mb-0 fw-bold">NUMBER OF ORIGNALS</p>
                          <p className="mb-0">{updateTotalOriginals}</p>
                        </div>

                        <div className="col-12 py-2">
                          <p className="mb-0 fw-bold">FREIGHT</p>
                          <p className="mb-0">{updateFreightPayment}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 text-center py-2 border">
                      <p>WEIGHT & MEASUREMENT OF CONTAINER NOT TO BE INCLUDED</p>
                      <p>(TERMS CONTINUED ON BACK HEREOF)</p>
                    </div>
                  </div>
                </div>

                <div className="col-3 border py-2">
                  <div className="col-12">
                    <p className="mb-0 fw-bold">PLACE & DATE OF ISSUE</p>
                    <p>{updateIssuePlace}</p>
                    <p>{updateIssueDate}</p>
                  </div>

                  <div className="col-12 py-2 text-center">
                    {printWithStamp?<img src={updateSigningEntity?.stamp} class="img-fluid" height={100} width={100}></img>:""}
                    {printWithSignature?<img src={updateSigningEntity?.signature} class="img-fluid" height={100} width={100}></img>:""}
                    <div className="py-2 text-center d-flex flex-column justify-content-end" style={{ "height": printWithStamp|printWithSignature?"":"150px" }}>
                      <p className="mb-0 fw-bold">{updateSigningEntity?.name}</p>
                      <p className="font-10px">AS {updateSignAs}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => [setShowPreviewPrintBlModal(false), setPrintWithClause(false), setPrintWithStamp(false), setPrintWithSignature(false)]}>Cancel</Button>

              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={() => downloadPDF("blDocument", "bl_"+updateBlNumber)}>Print</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/*  --------------------------- ISSUE BL --------------------------- */}
      <Modal size="xl" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showBlBackModal} onHide={() => setShowBlBackModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Print Bill of Lading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12" id="blBackDocument">
              <img src={blBackSideTerms} class="img-fluid w-100"></img>
            </div>

            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => setShowBlBackModal(false)}>Cancel</Button>

              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={() => downloadPDF("blBackDocument", "bl_back_"+updateBlNumber)}>Print</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default PlannedExportBl;
